import request from '@/utils/request';

// 工程师报表
export const getEngineerStatistics = (params: any) =>
  request({
    url: 'Dashboard/engineer',
    method: 'GET',
    params
  });

// 导出excel 工程师列表
export const exportEngineerStatistics = (params: any) =>
  request({
    url: 'Dashboard/exportEngineer',
    method: 'GET',
    params
  });
